import { render } from "./ListExperiments.vue?vue&type=template&id=2e843fe4&scoped=true&ts=true"
import script from "./ListExperiments.vue?vue&type=script&lang=ts"
export * from "./ListExperiments.vue?vue&type=script&lang=ts"

import "./ListExperiments.vue?vue&type=style&index=0&id=2e843fe4&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e843fe4"]])

export default __exports__